import React, {Component} from "react";
import {AgGridReact} from "ag-grid-react";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';
import {userActions} from "../../authentication/_actions";
import apiClient from "api/client";
import {Col, Grid, Row} from "react-bootstrap";
import Card from "../Card/Card";

class LiveChannelOrderingForCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columnDefs: [
                // Drag handle (recommended) so users don't accidentally drag when editing
                {
                    headerName: "",
                    width: 50,
                    rowDrag: true,
                    sortable: false,
                    filter: false,
                    suppressMenu: true,
                    pinned: 'left',
                    lockPosition: true,
                    cellClass: 'ag-row-drag',
                },
                {
                    width: 80,
                    field: "channel_id",
                },
                {
                    width: 80,
                    field: "position",
                    editable: true,
                },
                {field: "asset_name"},
                {field: "asset_image"}
            ],
            defaultColDef: {
                width: 150,
                sortable: false,
                filter: false
            },
            rowData: [],

            channels: [],
            loading: false,
            dirty: false,
            saving: false
        };
    }

    loadImage(value) {

        let image = "";

        if (value === null || value === undefined || value === '' || value === 'comp_') {
            //return image;
        } else {
            //return image;
        }

        return (
            <div className="center">
                <img
                    src={image}
                    width="50px" height="40" alt={""}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = process.env.REACT_APP_ASSET_URL + "/global/landscape_image_broken.png"
                    }}
                />
            </div>
        );

    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(prevProps);
        // console.log(this.props);
        if (this.props.categoryId !== prevProps.categoryId) {
            this.loadData();
        }
    }

    loadData() {

        let categoryId = this.props.categoryId

        if (categoryId) {
            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {'X-Id-Token': token}
            };


            let dataUrl = process.env.REACT_APP_API_URL + "/LiveCategories/" + categoryId + "/channels";

            apiClient.get(dataUrl, axiosConfig).then(response => {
                const channels = response.data;
                const loading = false;
                this.setState({channels, loading});
            }).catch(error => {
                this.setState({
                    loading: false,
                    dirty: false,
                    saving: false
                });
                //this.props.dispatch(userActions.logoutUnauthorized());
                console.log(error);
            });

        }


    }

    getCurrentGridOrder() {
        const ordered = [];
        if (this.gridApi) {
            this.gridApi.forEachNodeAfterFilterAndSort((node) => {
                if (node && node.data) ordered.push(node.data);
            });
        } else {
            ordered.push(...(this.state.channels || []));
        }
        return ordered.map((row, idx) => ({...row, position: idx}));
    }

    markDirtyAndSyncGrid(ordered) {
        this.setState({channels: ordered, dirty: true}, () => {
            if (this.gridApi) {
                this.gridApi.setRowData(this.state.channels);
            }
        });
    }

    saveOrder() {
        const categoryId = this.props.categoryId;
        if (!categoryId) return;

        const ordered = this.getCurrentGridOrder();

        let user = JSON.parse(localStorage.getItem('user'));
        let token = "";
        if (user) token = user.token;
        else this.props.dispatch(userActions.logoutUnauthorized());

        let axiosConfig = {headers: {'X-Id-Token': token, 'Content-Type': 'application/json'}};

        const url = process.env.REACT_APP_API_URL + "/LiveCategories/" + categoryId + "/channels-order";
        const payload = {items: ordered.map(r => ({id: r.id, channel_id: r.channel_id, position: r.position}))};

        this.setState({saving: true});
        apiClient.put(url, payload, axiosConfig)
            .then(() => {
                this.setState({saving: false, dirty: false});
                this.loadData();
            })
            .catch((error) => {
                console.log(error);
                this.setState({saving: false});
            });
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.loadData()
    };

    onRowDragEnter(e) {
        //console.log("onRowDragEnter", e);
    }

    onRowDragEnd(e) {
        const ordered = this.getCurrentGridOrder();
        this.markDirtyAndSyncGrid(ordered);
    }

    onRowDragMove(e) {
        //console.log("onRowDragMove", e);
    }

    onRowDragLeave(e) {
        //console.log("onRowDragLeave", e);
    }

    onCellEdit(e) {
        if (!e || !e.data) return;
        if (e.colDef && e.colDef.field === 'position') {
            const newPosRaw = Number(e.newValue);
            if (!Number.isFinite(newPosRaw)) return;
            const newPos = Math.max(0, Math.min((this.state.channels?.length || 1) - 1, Math.floor(newPosRaw)));
            const curr = [...(this.state.channels || [])];
            const idx = curr.findIndex(r => r.id === e.data.id);
            if (idx === -1) return;
            const [moved] = curr.splice(idx, 1);
            curr.splice(newPos, 0, moved);
            const normalized = curr.map((r, i) => ({...r, position: i}));
            this.markDirtyAndSyncGrid(normalized);
        }
    }

    render() {
        return (
            // <div className="main-content">
            <Row>

                <Col md={12}>
                    <Card
                        title={"Channel Order in category"}
                        category={"Reorder locally (Double click position to changed it), then click Save to submit"}
                        content={
                            <div>
                                <legend></legend>
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            {/*<div style={{width: "100%", height: "100%"}}>*/}
                                            {this.state.loading ? (
                                                <div className="text-center" style={{padding: "40px 0"}}>
                                                    <i className="fa fa-spinner fa-spin"/> Loading...
                                                </div>
                                            ) : (this.state.channels && this.state.channels.length > 0) ? (
                                                <div>
                                                    <div className="clearfix" style={{marginBottom: "10px"}}>
                                                        <button
                                                            className="btn btn-success btn-fill pull-right"
                                                            disabled={!this.state.dirty || this.state.saving}
                                                            onClick={() => this.saveOrder()}
                                                        >
                                                            {this.state.saving ? "Saving..." : "Save ordering"}
                                                        </button>
                                                        <div className="text-muted" style={{paddingTop: "8px"}}>
                                                            Drag rows or edit the <b>position</b> column. Changes are
                                                            kept locally until you save.
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="myGrid"
                                                        style={{
                                                            height: "609px",
                                                            width: "100%"
                                                        }}
                                                        className="ag-theme-balham"
                                                    >
                                                        <AgGridReact
                                                            columnDefs={this.state.columnDefs}
                                                            defaultColDef={this.state.defaultColDef}
                                                            rowDragManaged={true}
                                                            animateRows={true}
                                                            suppressMoveWhenRowDragging={true}
                                                            onGridReady={this.onGridReady}
                                                            rowData={this.state.channels}
                                                            onRowDragEnter={this.onRowDragEnter.bind(this)}
                                                            onRowDragEnd={this.onRowDragEnd.bind(this)}
                                                            onRowDragMove={this.onRowDragMove.bind(this)}
                                                            onRowDragLeave={this.onRowDragLeave.bind(this)}
                                                            onCellValueChanged={this.onCellEdit.bind(this)}
                                                        />
                                                    </div>
                                                    {/*</div>*/}
                                                </div>
                                            ) : (
                                                <div className="text-muted" style={{padding: "20px"}}>
                                                    No Live channels found for this category.
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                        }
                    />
                </Col>
            </Row>
            // </div>

        );
    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedLiveChannelOrderingForCategory = connect(mapStateToProps)(LiveChannelOrderingForCategory);
const connectedLiveChannelOrderingForCategoryTrans = withNamespaces('common')(connectedLiveChannelOrderingForCategory);
export {connectedLiveChannelOrderingForCategoryTrans as LiveChannelOrderingForCategory};
